import React from "react";

const IframeFooter = () => {
  return (
    <footer className=" flex flex-col items-center justify-center !min-h-[50px] !mb-0 bg-[#000d44] !py-[5px] mb-[30px] px-[20px]">
      <p className="text-[#fff] font-[400] text-center text-[14px] ">
        {" "}
        Copyright © 2025 Abhijeet Danve/Rheum Solutions LLC. All rights
        reserved. The A-Tool© is registered with the U.S. Copyright Office{" "}
      </p>
    </footer>
  );
};

export default IframeFooter;
